import React, { useEffect } from 'react';
import { Menu, Avatar } from 'antd';
import {
  HomeOutlined,
  UserOutlined,
  CalendarOutlined,
  AppstoreOutlined,
  TableOutlined,
  EditOutlined,
  AccountBookFilled,
  LinkOutlined,
  DollarOutlined, // ✅ Added icon for Payment tab
} from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';

function Sidebar({ collapsed, user }) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    console.log("Sidebar Props -> Collapsed:", collapsed);
    console.log("Sidebar Props -> User:", user);
  }, [collapsed, user]);

  if (!user) {
    return (
      <div
        style={{
          textAlign: 'center',
          padding: collapsed ? '10px' : '20px',
          background: '#001529',
          color: '#fff',
        }}
      >
        Loading...
      </div>
    );
  }

  // ✅ Select active tab
  const selectedKey =
    location.pathname === '/dashboard' ? '1' :
    location.pathname === '/user' ? '2' :
    location.pathname === '/meetings' ? '3' :
    location.pathname === '/slots' ? '4' :
    location.pathname === '/data' ? '5' :
    location.pathname === '/web' ? '6' :
    location.pathname === `/update-profile/${user?.company_id || ''}` ? '7' :
    location.pathname === '/accounts' ? '8' :
    location.pathname === '/view-link' ? '9' :
    location.pathname === '/payment' ? '10' : // ✅ Payment tab route
    '1';

  const handleOpenProfileTab = () => {
    if (user?.company_id) {
      navigate(`/update-profile/${user.company_id}`);
    } else {
      console.warn("User not loaded yet!");
    }
  };

  return (
    <div
      style={{
        textAlign: 'center',
        padding: collapsed ? '10px' : '20px',
        background: '#001529',
        minHeight: '100vh',
      }}
    >
    <div
  style={{
    width: collapsed ? 40 : 64,
    height: collapsed ? 40 : 64,
    borderRadius: "50%",
    overflow: "hidden",
    margin: "0 auto 10px auto",
    backgroundColor: "transparent",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }}
>
  <img
    src={user?.logo}
    alt="logo"
    style={{
      width: "100%",
      height: "100%",
      objectFit: "contain",   // 👈 perfect circle fit
    }}
  />
</div>


      {!collapsed && (
        <div
          style={{
            color: '#fff',
            fontSize: 16,
            marginBottom: 20,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {user?.company_name || 'No Company Name'}
        </div>
      )}

      <Menu theme="dark" mode="inline" selectedKeys={[selectedKey]}>
        <Menu.Item key="1" icon={<HomeOutlined />} onClick={() => navigate('/dashboard')}>
          Home
        </Menu.Item>
        <Menu.Item key="2" icon={<UserOutlined />} onClick={() => navigate('/user')}>
          Profile
        </Menu.Item>
        <Menu.Item key="3" icon={<CalendarOutlined />} onClick={() => navigate('/meetings')}>
          Meetings
        </Menu.Item>
        <Menu.Item key="4" icon={<AppstoreOutlined />} onClick={() => navigate('/slots')}>
          All Slots
        </Menu.Item>
        <Menu.Item key="5" icon={<TableOutlined />} onClick={() => navigate('/data')}>
          Slot Table
        </Menu.Item>
        <Menu.Item key="6" icon={<TableOutlined />} onClick={() => navigate('/web')}>
          Web Conferencing Slots
        </Menu.Item>
        <Menu.Item key="7" icon={<EditOutlined />} onClick={handleOpenProfileTab}>
          Update Profile
        </Menu.Item>
        <Menu.Item key="8" icon={<AccountBookFilled />} onClick={() => navigate('/accounts')}>
          Accounts
        </Menu.Item>
        <Menu.Item key="9" icon={<LinkOutlined />} onClick={() => navigate('/view-link')}>
          View Link
        </Menu.Item>

        {/* 💳 New Payment Tab */}
        <Menu.Item key="10" icon={<DollarOutlined />} onClick={() => navigate('/pricing')}>
          Pricing & Payments
        </Menu.Item>
      </Menu>
    </div>
  );
}

export default Sidebar;
